const FRACTIONS: ReadonlyArray<readonly [number, string]> = [
  [1 / 2, "1/2"],
  [1 / 3, "1/3"],
  [2 / 3, "2/3"],
  [1 / 4, "1/4"],
  [3 / 4, "3/4"],
  [1 / 5, "1/5"],
  [2 / 5, "2/5"],
  [3 / 5, "3/5"],
  [4 / 5, "4/5"],
  [1 / 6, "1/6"],
  [5 / 6, "5/6"],
  [1 / 8, "1/8"],
  [3 / 8, "3/8"],
  [5 / 8, "5/8"],
  [7 / 8, "7/8"],
];

function formatDecimal(value: number, fractionDigits: number): string {
  return value
    .toFixed(fractionDigits)
    .replace(/(\.\d*?[1-9])0+$/u, "$1")
    .replace(/\.0+$/u, "");
}

export function formatNumber(value: number, fractionDigits: number = 0): string {
  if (value > 10) {
    return formatDecimal(value, fractionDigits);
  }

  if (Number.isInteger(value)) {
    return value.toString();
  }

  const whole = Math.floor(value);
  const fraction = value - whole;

  let closest: string | null = null;
  let minDiff = 0.02;
  for (const [fractionValue, label] of FRACTIONS) {
    const diff = Math.abs(fraction - fractionValue);
    if (diff < minDiff) {
      closest = label;
      minDiff = diff;
    }
  }

  if (closest) {
    return whole > 0 ? `${whole} ${closest}` : closest;
  }

  return formatDecimal(value, fractionDigits);
}
